import { render, staticRenderFns } from "./StudentUserLearnDetectionPage.vue?vue&type=template&id=9cdbd23c"
import script from "./StudentUserLearnDetectionPage.vue?vue&type=script&lang=js"
export * from "./StudentUserLearnDetectionPage.vue?vue&type=script&lang=js"
import style0 from "./StudentUserLearnDetectionPage.vue?vue&type=style&index=0&id=9cdbd23c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports